// HACK: This demo doesn't really fit the regular format, but it's useul to have it somewhere.

import { component, demoFile, story, variant, componentWithVariants } from "system/demo";
import { useDatastore, useModuleGlobal, useModuleObject, useUserData } from "util/datastore";
import { defineModuleGlobal, defineModuleMap } from "util/moduledata";
import { View } from "react-native";
import { CTAButton } from 'component/button';
import { UtilityText } from 'component/text';
import { EmbeddedInstance } from "util/instance";
import { HorizBox, Pad } from 'component/basics';
import { CLICK } from "system/demo";
import { sendTestEvent, TestEventReceiver } from "util/testevents";


demoFile('component/data-model');



const moduleGlobalWibble = defineModuleGlobal<string>("USER_GLOBAL", 'foo', 'wibble');
const moduleMapKing = defineModuleMap<string>("USER_LOCAL", 'bar', 'king');
const moduleMapOne = defineModuleMap<string>("PUBLIC", 'baz', 'one');

function UserDataDemo() {
    const datastore = useDatastore();
    const globalVar = useModuleGlobal(moduleGlobalWibble);
    const localVar = useModuleObject(moduleMapKing, 'kong');
    const publicVar = useModuleObject(moduleMapOne, 'two');

    useUserData();
    return <View>
        <UtilityText text={'Global Var: ' + globalVar} />
        <UtilityText text={'Local Var: ' + localVar}  />
        <UtilityText text={'Public Var: ' + publicVar}  />
        <Pad />
        <HorizBox spread>
            <CTAButton text='Change Global Var' onPress={async () => 
                await datastore.setModuleGlobalAsync(moduleGlobalWibble, 'new global')
            } />
            <CTAButton text='Change Local Var' onPress={async () => 
                await datastore.setModuleObjectAsync(moduleMapKing, 'kong', 'new local')
            } />
        </HorizBox>
    </View>
}

component('UserData', UserDataDemo, {
    state: {
        moduleUserGlobal: {foo: {wibble: 'initial global'}},
        moduleUserLocal: {bar: {king: {kong: 'initial local'}}},
        modulePublic: {baz: {one: {two: 'initial public'}}},
    }
}, [
    story('Change Global Var', [
        CLICK('Change Global Var')
    ]),
    story('Change Local Var', [
        CLICK('Change Local Var')
    ]),
    story('Change global then local', [
        CLICK('Change Global Var'),
        CLICK('Change Local Var')
    ])
]);

componentWithVariants('EmbeddedInstance', EmbeddedInstance, {}, [
    variant('Feature Override', {
        args: {
            structureKey: 'simplecomments',
            instanceKey: 'demo',
            features: {demoFilter: true}
        },
        state: {
            embeddedInstanceData: {simplecomments: {demo: {
                collections: {comment: [
                    {key: 1, from: 'a', text: 'This is a comment in an embedded instance'},
                ]},
            }}},    
        }
    }),
    variant('Subscreen', {
        args: {
            structureKey: 'simplecomments',
            instanceKey: 'demo',
            screenKey: 'composer',
            features: {lengthlimit: true}
        },
        state: {
            embeddedInstanceData: {simplecomments: {demo: {
                collections: {comment: [
                    {key: 1, from: 'a', text: 'This is a comment in an embedded instance'},
                ]},
            }}},    
        }
    })
]);

const TestEventReceiverDemo = () => <View>
    <TestEventReceiver sinkKey='test-event-receiver-1' />
    <TestEventReceiver sinkKey='test-event-receiver-2' />
    <CTAButton text='Send Test Event' onPress={() => sendTestEvent('test-event-receiver-1', 'test event')} />
    <CTAButton text='Send Second Event' onPress={() => sendTestEvent('test-event-receiver-2', 'second test event')} />
</View>;
component('TestEventReceiver', TestEventReceiverDemo, {}, [
    story('Send Two Test Events', [
        CLICK('Send Test Event'),
        CLICK('Send Second Event')
    ])
])
